// extracted by mini-css-extract-plugin
module.exports = {"dragAndDrop":"DragAndDrop_dragAndDrop__3rFOi","dragging":"DragAndDrop_dragging__2OMJg"};